let __wxPageOption;
//模拟微信小程序逻辑 微信小程序有Page全局变量进行执行
function Page(option){
	  __wxPageOption = option;
}

import {createPageConfig} from './login.build';
Page(createPageConfig());
export default createPageConfig;